<template>
  <VSnackbar
    v-model="isNotification"
    :color="notificationType"
    :multi-line="true"
    :auto-height="true"
  >
    <p
      v-for="(alert, index) in notificationTextArr"
      :key="index"
    >
      {{ alert }}
    </p>
    <VBtn
      dark
      flat
      @click="isNotification = false"
    >
      {{ $nt('close') }}
    </VBtn>
  </VSnackbar>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'GlobalNotifications',
  computed: {
    ...mapFields('notification', ['isNotification', 'notificationTextArr', 'notificationType'])
  }
}
</script>
